<div class="participant-details-tab">

  <div class="pdt-toolbar">
    <h2 class="section-title">Participants</h2>
    <button mat-stroked-button (click)="load()" [disabled]="isLoading">
      <mat-icon>refresh</mat-icon> Refresh
    </button>
  </div>

  <!-- Loading -->
  <div *ngIf="isLoading" class="state-box">
    <mat-progress-spinner mode="indeterminate" diameter="36"></mat-progress-spinner>
  </div>

  <!-- Error -->
  <div *ngIf="!isLoading && loadError" class="state-box state-error">
    <mat-icon>error_outline</mat-icon>
    <p>{{ loadError }}</p>
    <button mat-stroked-button (click)="load()">Retry</button>
  </div>

  <!-- Class not yet confirmed -->
  <div *ngIf="!isLoading && !loadError && notConfirmedMessage" class="state-box state-unconfirmed">
    <mat-icon>pending_actions</mat-icon>
    <p class="state-title">Class not confirmed yet</p>
    <p class="state-sub">{{ notConfirmedMessage }}</p>
    <button mat-stroked-button (click)="goToSettingsParticipants.emit()">
      Go to Settings &rarr; Participants
    </button>
  </div>

  <!-- Empty (confirmed but no participants) -->
  <div *ngIf="!isLoading && !loadError && !notConfirmedMessage && tableSource.data.length === 0" class="state-box state-empty">
    <mat-icon>people_outline</mat-icon>
    <p>No participants enrolled in this class yet.</p>
    <button mat-stroked-button (click)="goToSettingsParticipants.emit()">
      <mat-icon>settings</mat-icon> Go to Settings &rarr; Participants
    </button>
  </div>

  <!-- Table -->
  <div *ngIf="!isLoading && !loadError && !notConfirmedMessage && tableSource.data.length > 0" class="table-container">
    <table mat-table [dataSource]="tableSource" class="pdt-table">

      <!-- Login ID -->
      <ng-container matColumnDef="loginId">
        <th mat-header-cell *matHeaderCellDef>Login ID</th>
        <td mat-cell *matCellDef="let p">{{ p.loginId }}</td>
      </ng-container>

      <!-- Type (email vs ad-hoc) -->
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let p">
          <span *ngIf="p.isAdhoc" class="type-chip type-chip-adhoc">
            <mat-icon class="chip-icon">badge</mat-icon> Ad-hoc
          </span>
          <span *ngIf="!p.isAdhoc" class="type-chip type-chip-email">
            <mat-icon class="chip-icon">alternate_email</mat-icon> Email
          </span>
        </td>
      </ng-container>

      <!-- Redemption status -->
      <ng-container matColumnDef="redemptionStatus">
        <th mat-header-cell *matHeaderCellDef>Redeemed?</th>
        <td mat-cell *matCellDef="let p">
          <span *ngIf="!p.hasKey" class="status-badge status-nokey">No key</span>
          <span *ngIf="p.hasKey && p.alreadyRedeemed" class="status-badge status-redeemed">
            <mat-icon class="badge-icon">check_circle</mat-icon>
            {{ p.redemptionDate ? (p.redemptionDate | date:'dd MMM yyyy') : 'Yes' }}
          </span>
          <span *ngIf="p.hasKey && !p.alreadyRedeemed" class="status-badge status-pending">
            Pending
          </span>
        </td>
      </ng-container>

      <!-- Redeemed by (may differ from loginId for cross-account) -->
      <ng-container matColumnDef="redeemedBy">
        <th mat-header-cell *matHeaderCellDef>Redeemed by</th>
        <td mat-cell *matCellDef="let p">
          <span *ngIf="p.redeemedByEmail">{{ p.redeemedByEmail }}</span>
          <span *ngIf="!p.redeemedByEmail" class="text-muted">—</span>
        </td>
      </ng-container>

      <!-- Cross-account flag -->
      <ng-container matColumnDef="crossAccount">
        <th mat-header-cell *matHeaderCellDef>Cross-account?</th>
        <td mat-cell *matCellDef="let p">
          <mat-icon *ngIf="p.crossAccountRedemption"
            class="cross-account-icon"
            matTooltip="Key redeemed by a different email than the enrolled login ID">
            warning_amber
          </mat-icon>
          <span *ngIf="!p.crossAccountRedemption" class="text-muted">—</span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" appPersistPageSize="class:participantDetails:list" showFirstLastButtons></mat-paginator>

    <p class="total-line">Total: {{ tableSource.data.length }} participant(s)</p>
  </div>

</div>
